"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTimeString = exports.useBotOrderCount = exports.useMoveUSBotDataSource = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const Global_1 = require("../Orders/Global");
const utils_1 = require("../TradeUtils/Share/utils");
const lodash_1 = require("lodash");
const MoveUSTools_1 = require("./MoveUSTools");
const DisableOrderTypes = [
    TradeAPILib_1.ExchangeOrderType.gridLeverage,
    TradeAPILib_1.ExchangeOrderType.gridLeverageShort,
    TradeAPILib_1.ExchangeOrderType.gridLoan,
    TradeAPILib_1.ExchangeOrderType.fsa,
    TradeAPILib_1.ExchangeOrderType.cm_fsa,
];
const useMoveUSBotDataSource = (tradeAPI, orderWebsocketObserve, tickerObserve, isFocused = true, isBot = true) => {
    const [dataSource, setDataSource] = (0, react_1.useState)([]);
    const [refreshing, setRefreshing] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const [wsOrder, setWSOrder] = (0, react_1.useState)();
    const exchange = (0, react_1.useMemo)(() => {
        return tradeAPI === null || tradeAPI === void 0 ? void 0 : tradeAPI.getInnerApiKeyInfo().market;
    }, [tradeAPI]);
    const tickerMap = (0, Global_1.useBotOrdersTickerWebsocket)(exchange || "", dataSource, tickerObserve, isFocused);
    const refreshDataSource = (0, react_1.useCallback)(() => {
        if (!tradeAPI) {
            setError({ code: -1, message: "no trade api" });
            return;
        }
        if (refreshing || isFocused === false) {
            return;
        }
        setRefreshing(true);
        // 美国站支持的交易对
        const $enableSymbols = (0, MoveUSTools_1.USSymbolStringsObservable)();
        // 美国站不支持的策略
        const $disableOrderType = (0, rxjs_1.of)(DisableOrderTypes);
        const $botOrders = queryAllRuningBotOrders(tradeAPI).pipe((0, operators_1.map)((res) => {
            if (isBot) {
                return res.filter((ele) => {
                    return ele.orderType !== TradeAPILib_1.ExchangeOrderType.fsa && ele.orderType !== TradeAPILib_1.ExchangeOrderType.cm_fsa;
                });
            }
            else {
                return res.filter((ele) => {
                    return ele.orderType === TradeAPILib_1.ExchangeOrderType.fsa || ele.orderType === TradeAPILib_1.ExchangeOrderType.cm_fsa;
                });
            }
        }), (0, operators_1.catchError)((error) => {
            console.log(error);
            throw error;
        }));
        return (0, rxjs_1.combineLatest)($enableSymbols, $disableOrderType, $botOrders)
            .pipe((0, operators_1.map)(([enableSymbols, disableOrderType, orders]) => {
            const filterData = orders.filter((order) => {
                var _a, _b, _c, _d, _e, _f, _g;
                // 不支持的策略全部true
                const isOrderTypeDisable = disableOrderType.some((res) => {
                    return order.orderType === res;
                });
                if (isOrderTypeDisable) {
                    return true;
                }
                // 订单的交易对有不在白名单中的, return true
                if (order.orderType === TradeAPILib_1.ExchangeOrderType.SR) {
                    let isAllValid = true;
                    for (let e of (_b = (_a = order.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.coins) !== null && _b !== void 0 ? _b : []) {
                        const orderSymbol = `${e.base}/${order.quote}`;
                        const isSymbolValid = enableSymbols.some((s) => {
                            return s.symbol === orderSymbol;
                        });
                        if (!isSymbolValid) {
                            isAllValid = false;
                            break;
                        }
                    }
                    // 全都合规就不关单了返回false;
                    return !isAllValid;
                }
                else if (order.orderType === TradeAPILib_1.ExchangeOrderType.martingale && ((_c = order.exchangeMTGOrder) === null || _c === void 0 ? void 0 : _c.isMulti)) {
                    let isAllValid = true;
                    for (let e of (_e = (_d = order.exchangeMTGOrder) === null || _d === void 0 ? void 0 : _d.coins) !== null && _e !== void 0 ? _e : []) {
                        const orderSymbol = `${e.base}/${order.quote}`;
                        const isSymbolValid = enableSymbols.some((s) => {
                            return s.symbol === orderSymbol;
                        });
                        if (!isSymbolValid) {
                            isAllValid = false;
                            break;
                        }
                    }
                    return !isAllValid;
                }
                else if (order.orderType === TradeAPILib_1.ExchangeOrderType.SC) {
                    let isAllValid = true;
                    for (let e of (_g = (_f = order.exchangeSCOrder) === null || _f === void 0 ? void 0 : _f.coins) !== null && _g !== void 0 ? _g : []) {
                        const orderSymbol = `${e.base}/${order.quote}`;
                        const isSymbolValid = enableSymbols.some((s) => {
                            return s.symbol === orderSymbol;
                        });
                        if (!isSymbolValid) {
                            isAllValid = false;
                            break;
                        }
                    }
                    return !isAllValid;
                }
                else {
                    const isValid = enableSymbols.some((s) => {
                        return s.symbol === order.symbol;
                    });
                    return !isValid;
                }
            });
            return filterData;
        }))
            .subscribe((res) => {
            setDataSource(res);
            setRefreshing(false);
            setError(undefined);
        }, (error) => {
            setDataSource([]);
            setRefreshing(false);
            setError(error);
        });
    }, [refreshing, tradeAPI, isFocused, isBot]);
    // 默认请求data source
    (0, react_1.useEffect)(() => {
        if (!isFocused) {
            return;
        }
        const sub = refreshDataSource();
        return () => {
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tradeAPI, isFocused]);
    // 监听websocket
    (0, react_1.useEffect)(() => {
        if (!exchange || !isFocused || !orderWebsocketObserve) {
            return;
        }
        const sub = (0, Global_1.BotOrderWebSocketObservable)(orderWebsocketObserve, exchange).subscribe((res) => {
            setWSOrder(res);
        }, (error) => { });
        return () => {
            sub.unsubscribe();
        };
    }, [orderWebsocketObserve, exchange, isFocused]);
    // 合并websocket数据
    (0, react_1.useEffect)(() => {
        if (!wsOrder || refreshing) {
            return;
        }
        let changed = false;
        for (let i = 0; i < dataSource.length; i++) {
            const order = dataSource[i];
            if (order.id !== (wsOrder === null || wsOrder === void 0 ? void 0 : wsOrder.id)) {
                continue;
            }
            const newOrder = TradeAPILib_1.TradeUtils.convertToExchangeOrder((0, lodash_1.merge)(order.originOrderData, wsOrder.originOrderData));
            if (newOrder === null || newOrder === void 0 ? void 0 : newOrder.isRunning) {
                dataSource.splice(i, 1, newOrder);
            }
            else {
                dataSource.splice(i, 1);
            }
            changed = true;
            break;
        }
        changed && setDataSource(new Array().concat(dataSource));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wsOrder, refreshing]);
    (0, react_1.useEffect)(() => {
        if (!exchange) {
            return;
        }
        const parseDataSource = dataSource.map((order) => {
            var _a, _b, _c;
            const market = order.exchange || exchange;
            let ticker;
            const tickers = [];
            switch (order.orderType) {
                case TradeAPILib_1.ExchangeOrderType.SR:
                    (_a = order.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.coins.forEach((srCoin) => {
                        const tempTicker = tickerMap.get(`${market}/${srCoin.base}/${order.quote}`);
                        if (tempTicker) {
                            tickers.push(tempTicker);
                        }
                    });
                    break;
                case TradeAPILib_1.ExchangeOrderType.martingale:
                    (_b = order.exchangeMTGOrder) === null || _b === void 0 ? void 0 : _b.coins.forEach((mtgCoin) => {
                        const tempTicker = tickerMap.get(`${market}/${mtgCoin.base}/${order.quote}`);
                        if (tempTicker) {
                            tickers.push(tempTicker);
                        }
                    });
                    break;
                case TradeAPILib_1.ExchangeOrderType.SC:
                    (_c = order.exchangeSCOrder) === null || _c === void 0 ? void 0 : _c.coins.forEach((scCoin) => {
                        const tempTicker = tickerMap.get(`${order.exchange}/${scCoin.base}/${order.quote}`);
                        if (tempTicker !== undefined) {
                            tickers.push(tempTicker);
                        }
                    });
                    break;
                default:
                    ticker = tickerMap.get(`${market}/${order.base}/${order.quote}`);
                    break;
            }
            return TradeAPILib_1.TradeUtils.calcGridOrderProfit(order, ticker ? Number(ticker.latest) : 0, 0, tickers);
        });
        setDataSource(new Array().concat(parseDataSource));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exchange, tickerMap]);
    return {
        dataSource: dataSource,
        refreshing: refreshing,
        error: error,
        refreshListFunc: refreshDataSource,
    };
};
exports.useMoveUSBotDataSource = useMoveUSBotDataSource;
const queryBotOrderCount = (tradeAPI) => {
    return tradeAPI.getMarketBotOrdersCountByStatus({ status: "running" });
};
const useBotOrderCount = (tradeAPI) => {
    const [count, setCount] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        queryBotOrderCount(tradeAPI).subscribe((data) => {
            setCount(data);
        }, (error) => { });
    }, [tradeAPI]);
};
exports.useBotOrderCount = useBotOrderCount;
const queryAllRuningBotOrders = (tradeAPI) => {
    return queryBotOrderCount(tradeAPI).pipe((0, operators_1.flatMap)((count) => {
        if (count <= 0) {
            return (0, rxjs_1.of)([]);
        }
        const obs = [];
        const pageSize = 100;
        const pages = new trade_utils_lib_1.SafeDecimal(count).div(pageSize).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL).toNumber();
        for (let i = 0; i < pages; i++) {
            obs.push(tradeAPI.getQueryBotOrdersMoreV2({ status: "running", pageNo: i, pageNum: pageSize }));
        }
        return (0, rxjs_1.forkJoin)(obs).pipe((0, operators_1.map)((res) => {
            return res.reduce((pre, cur) => {
                return pre.concat(cur);
            });
        }));
    }));
};
const UpdateTimeString = (timestamp, $st) => {
    const startTime = timestamp;
    const endTime = new Date().getTime();
    const lasting = endTime - startTime;
    const timeResult = (0, utils_1.getFormatTimeLasting)(lasting);
    return `${$st("lasting")} ${timeResult.day}${$st("grid_order_lasting_day")}${timeResult.hour}${$st("grid_order_lasting_hour")}${timeResult.minute}${$st("grid_order_lasting_minute")}${timeResult.second}${$st("grid_order_lasting_second")}`;
};
exports.UpdateTimeString = UpdateTimeString;
